import * as React from "react";
import Box from "@mui/material/Box";
import Forms from "./Forms";

export default function ViewForm({
    showSkeleton,
    formValues,
    handleChange,
    fireApi,
    stateValue,
    error,
    data,
    lgaValue
}) {

    let formContent = [
        {
            name: "currentState",
            label: "Current State",
            type: "text",
            options: [],
            isReadOnly: true,
            value: formValues.currentState,
        },
        {
            name: "selectNewState",
            label: "Select New State",
            type: "asynchronous",
            options: data?.states,
            onChange: (e) => handleChange(e),
            value: stateValue,
            helperText: error.stateIdErrText,
            error: error.stateIdErr,
            dispatchAction: fireApi,
        },
        {
            name: "selectNewLGA",
            label: "Select New LGA",
            type: "asynchronous",
            options: data?.lgas,
            onChange: (e) => {
                data?.action(e)
            },
            value: lgaValue,
            helperText: error.lgaIdErrText,
            error: error.lgaIdErr,

        },
    ]
    return (
        <Box sx={{ width: "100%" }}>
            <React.Fragment>
                <Box p="30px 10px">
                    <Forms formContent={formContent} spacing={4} />
                </Box>
            </React.Fragment>
        </Box>
    );
}
